var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"overlay-container",class:{ scrollable: _vm.scrollable }},[_vm._t("default"),_c('button',{staticClass:"overlay-btn",on:{"click":_vm.hide}})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }